import React from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom';
import {
    Button,
    Divider,
    Grid,
    IconButton,
    Toolbar,
    Tooltip,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { privacy_url } from '../data';
import TermsOfService from '../TermsOfService';
import { useTranslation } from 'react-i18next';
import UpdateNotification from '../UpdateNotification/UpdateNotification.js';

const useStyles = makeStyles((theme) => ({
    indented: {
        marginLeft: theme.spacing(10),
    },
    content: {
        padding: theme.spacing(2),
    },
    table: {
        minWidth: 650,
        border: "none",
        boxShadow: "none"
    }
}));

export default function HelpPage() {
    const classes = useStyles();
    const history = useHistory();
    const [openTerms, setOpenTerms] = React.useState(false);
    const [showUpdateInfo, setShowUpdateInfo] = React.useState(false);
    const { t } = useTranslation();

    const handleCloseTerms = () => {
        setOpenTerms(false);
    };
    const handleOpenSoftwareInfo = () => {
        setShowUpdateInfo(true);
    };
    const clearShowUpdate = () => {
        setShowUpdateInfo(false);
    };

    const handleOpenTerms = () => {
        setOpenTerms(true);
    };

    return (
        <Grid container
            direction='column'
            justify='flex-start'
            alignItems='stretch'
            className={classes.content}>
            <Grid item xs>
                <Toolbar>
                    <Tooltip title={t("goHome")}>
                        <IconButton color='primary'
                            component={RouterLink}
                            onClick={() => history.goBack()}>
                            <ArrowBack />
                        </IconButton>
                    </Tooltip>
                    <Typography variant='h5'
                        color='textPrimary'>
                        {t("help")}
                    </Typography>
                </Toolbar>
            </Grid>
            <Grid item xs><Divider />
                <UpdateNotification signedIn={true} showUpdate={showUpdateInfo} onCloseFunction={clearShowUpdate}/>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                        <TableBody>
                            <TableRow >
                                <TableCell colSpan={2} align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                    <a href={"http://setup.gracopulse.com/level"} target="_blank">{t("setupGuide")}</a>
                                </TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell colSpan={2} align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                    <a href={"http://operation.gracopulse.com/level"} target="_blank">{t("operationGuide")}</a>
                                </TableCell>
                            </TableRow>
                            <TableRow >
                            <TableCell colSpan={2} align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                    <Button onClick={handleOpenSoftwareInfo} color='secondary' variant="contained" style={{ 'float': 'center', 'font-size': 12 }}>
                                        {t("recentChanges")}
                                    </Button>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={2} align="center" style={{ borderBottom: "none" }}>
                                    {t("forHelpEmail_colon")} <a href="mailto:ledtech@graco.com" target="_top">ledtech@graco.com</a>
                                </TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell colSpan={2} align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                    {t("techAssistancePhone")}
                                </TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell colSpan={2} align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                    <Button onClick={handleOpenTerms} variant="outlined" style={{ 'float': 'center', 'font-size': 12 }}>
                                        {t("termsAndConitions")}
                                    </Button>
                                </TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell colSpan={2} align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                    <a href={privacy_url} target="_blank">{t("privacy")}</a>
                                </TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell colSpan={2} align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                    <a href={"http://www.graco.com"} target="_blank">www.graco.com</a>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                {openTerms && <TermsOfService openTerms={openTerms} handleCloseTerms={handleCloseTerms} />}
            </Grid>
        </Grid>
    );
}
